import { Icon } from "~/components/icon";
import { slackChannelUrl } from "~/utils/slack";

export function SlackChannelLink({ channel }: { channel: string }) {
  return (
    <a
      href={slackChannelUrl(channel)}
      className="mt-1 inline-flex items-center gap-1.5 font-mono text-sm text-gray-900 underline underline-offset-2 hover:text-foreground/80"
    >
      <Icon name="Slack" size={14} />
      {channel}
    </a>
  );
}
